import React, {useState, useEffect} from 'react';

const VerticalProgress = ({type, goal, currentGoal}) => {

    const [color, setColor] = useState("");

    useEffect(() => {
        if (type === "accuracy") {
            setColor(currentGoal >= goal ? "#FAA201" : "#FAA201")
        } else {
            setColor(currentGoal <= goal ? "#FAA201" : "#FAA201")
        }
    }, [type])
    
    const clamp = (num) => {
        return Math.min(Math.max(num, 0), 100)
    }

    return (
        <div>
            <div className='vertical-progress'>
                <div className='vertical-progress-filled' style={{
                    height: type === "accuracy" ? `${clamp(currentGoal)}%` : `${clamp(currentGoal * 10)}%`,
                    background: color
                }}>
                </div>
                <div className='vertical-progress-hline' style={{
                    bottom: `${goal-1}%`
                }}>
                    <div className='vertical-progress-hline-text'>{type === "accuracy" ? goal : (goal/10).toFixed(0)}</div>
                </div>
                {/* <div className='vertical-progress-arrow' style={{
                    visibility: (currentGoal >= 100 || currentGoal === 0) ? "hidden" : "visible",
                    bottom: `${clamp(currentGoal)+2}%`,
                    borderTopColor: color,
                    transform: (type === "time" && currentGoal < goal || type === "accuracy" && currentGoal > goal) ?  "rotate(180deg)" : "",
                }}>
                </div> */}
                <div className='vertical-progress-arrow-text'  style={{
                        bottom: type === "accuracy" ? `${clamp(currentGoal) - 5}%` : `${clamp(currentGoal * 10)-4}%`,
                        right: "-25px",
                        color: color,
                    }}>{currentGoal}</div>
            </div>
        </div>
    );
}

export default VerticalProgress;
